import { ErrorBoundary } from "@components/ui/ErrorBoundary";
import { paths } from "@config/paths";
import { urls } from "@config/urls";
import { newVersionCheckLoader } from "@utils/new-version-check-loader";
import { v2RedirectLoader } from "@utils/v2-redirect-loader";
import { createBrowserRouter, redirect, RouterProvider } from "react-router";

const router = createBrowserRouter([
  {
    path: "/v2/*",
    loader: v2RedirectLoader,
  },
  {
    path: paths.root.path,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "",
        loader: () => redirect(urls.home),
      },
      {
        path: paths.orderTrackingStatus.path,
        lazy: async () => {
          const { OrderTrackingPage } = await import(
            "../pages/order-tracking/OrderTrackingPage"
          );
          return { Component: OrderTrackingPage };
        },
        loader: newVersionCheckLoader,
      },
      {
        path: paths.payment.path,
        lazy: async () => {
          const { PaymentPage } = await import("@pages/payment/PaymentPage");
          return { Component: PaymentPage };
        },
        loader: newVersionCheckLoader,
      },
      {
        path: paths.paymentCallbackMoyasar.path,
        lazy: async () => {
          const { PaymentCallbackPage } = await import(
            "@pages/payment/PaymentCallbackPage"
          );
          return { Component: PaymentCallbackPage };
        },
      },
      {
        path: paths.paymentCallbackTamara.path,
        lazy: async () => {
          const { PaymentCallbackPage } = await import(
            "@pages/payment/PaymentCallbackPage"
          );
          return { Component: PaymentCallbackPage };
        },
      },
      {
        path: paths.paymentCallbackTabby.path,
        lazy: async () => {
          const { PaymentCallbackPage } = await import(
            "@pages/payment/PaymentCallbackPage"
          );
          return { Component: PaymentCallbackPage };
        },
      },
      {
        path: paths.error.path,
        lazy: async () => {
          const { ErrorPage } = await import("@pages/misc/ErrorPage");
          return { Component: ErrorPage };
        },
      },
      {
        path: paths.orderConfirmed.path,
        lazy: async () => {
          const { OrderConfirmedPage } = await import(
            "@pages/payment/OrderConfirmedPage"
          );
          return { Component: OrderConfirmedPage };
        },
      },
    ],
  },
  {
    path: "*",
    lazy: async () => {
      const { NotFoundPage } = await import("@pages/misc/NotFoundPage");
      return {
        Component: () => <NotFoundPage />,
      };
    },
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
